module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_7.918dff5859d9995b98d06a18225ced5f.png";